import type { BuildOperationInput, BuildOperationResult } from "./operation.ts";
import detailFilterOperationLegacy from "./detail-filter-operation-legacy.ts";
import detailFilterOperationV2 from "./detail-filter-operation-v2.ts";
import { isLegacyDetailFilter } from "../model/detail-filter.ts";

function* detailFilterOperation(
	input: BuildOperationInput,
): Generator<undefined, BuildOperationResult> {
	const { config } = input;

	const { detailFilter } = config;
	if (!detailFilter) {
		return { type: "no-change" };
	}

	if (isLegacyDetailFilter(detailFilter)) {
		return yield* detailFilterOperationLegacy(input);
	}

	return yield* detailFilterOperationV2(input);
}

export default detailFilterOperation;
